import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { variants } from 'style/theme';

export const ProcessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StepImages = styled.div`
  display: flex;
  align-items: center;

  @media ${sizes.desktop} {
    flex-direction: ${({ hasClaims }) => (hasClaims ? 'row' : 'column')};
  }
`;

export const Divider = styled.div`
  align-self: center;
  width: 30px;
  height: 3px;
  background-color: #f8fafb;

  @media ${sizes.desktop} {
    height: ${({ hasClaims }) => (hasClaims ? '3px' : '30px')};
    width: ${({ hasClaims }) => (hasClaims ? '30px' : '3px')};
  }
`;

export const Description = styled.div``;

export const List = styled.ul`
  ${variants('variant', {
    small: css`
      padding-left: 20px;
    `
  })};

  > li {
    margin: 16px 0;
  }
`;

export const LearnMore = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const LearnMoreText = styled.div`
  font-size: 14px;
  font-weight: 700;
`;

export const LearnMoreArrow = styled.div`
  font-size: 20px;
  font-weight: 700;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.desktop} {
    flex-direction: ${({ hasClaims }) => (hasClaims ? 'column' : 'row')};
  }
`;
